export const COMMIT_HASH = '722f26c7439441c83b21744cadbb2af6ca12c149';
